import FormInput from 'components/Forms/FormInput';
import { useServerTranslation } from 'hooks/useServerTranslation';

export default function EmailPasswordInput() {
    const { t } = useServerTranslation();

    return (
        <>
            <FormInput
                label={t('form-fields.user.email')}
                name="email"
                type="email"
                required
                variant="outlined"
                size="small"
            />
            <FormInput
                label={t('form-fields.user.password')}
                name="password"
                type="password"
                required
                variant="outlined"
                size="small"
            />
        </>
    );
}
